import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar'; 
import Box from '@mui/material/Box'; 
import AppBar from '@mui/material/AppBar'; 
import Toolbar from '@mui/material/Toolbar'; 
import IconButton from '@mui/material/IconButton'; 
import MenuIcon from '@mui/icons-material/Menu'; 
import Typography from '@mui/material/Typography'; 
// (*** MỚI ***) Import hook để phát hiện màn hình
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function Layout({ children }) {
  // (*** SỬA ***) Logic phát hiện màn hình di động
  const theme = useTheme();
  // 'sm' (small) tương đương 600px. Dưới 600px sẽ là mobile
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); 

  // (*** SỬA ***) Khởi tạo trạng thái Sidebar
  // Mặc định TẮT trên mobile, BẬT trên desktop
  const [open, setOpen] = useState(!isMobile); 
  
  // (*** SỬA ***) Tự động đóng Sidebar khi chuyển sang mobile
  useEffect(() => {
    if (isMobile) {
      setOpen(false); // Tự động đóng khi màn hình thu nhỏ
    }
  }, [isMobile]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  
  // (*** MỚI ***) Hàm toggle cho mobile (vừa mở vừa đóng)
  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const drawerWidth = 240;

  return (
    <Box sx={{ display: 'flex' }}>
      {/* AppBar (Thanh header) */}
      <AppBar 
        position="fixed" 
        sx={{ 
          zIndex: (theme) => theme.zIndex.drawer + 1, 
          // (*** SỬA ***) Chỉ áp dụng hiệu ứng "đẩy" khi KHÔNG PHẢI mobile
          transition: (theme) => !isMobile ? theme.transitions.create(['width', 'margin'], { 
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }) : 'none',
          
          // (*** SỬA ***) Style khi Sidebar mở (CHỈ ÁP DỤNG cho desktop)
          ...(open && !isMobile && { 
            marginLeft: `${drawerWidth}px`, 
            width: `calc(100% - ${drawerWidth}px)`,
            transition: (theme) => theme.transitions.create(['width', 'margin'], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.enteringScreen,
            }),
          }),
        }}
      >
        <Toolbar>
          {/* (*** SỬA ***) Nút Mở/Đóng Sidebar (MenuIcon) */}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            // (*** SỬA ***) Dùng 1 hàm duy nhất
            // Trên mobile: nó sẽ toggle (bật/tắt)
            // Trên desktop: nó chỉ mở (vì nút đóng nằm trong sidebar)
            onClick={isMobile ? handleDrawerToggle : handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5, 
              // (*** SỬA ***) Chỉ ẩn nút này khi: 
              // 1. Sidebar đang MỞ
              // 2. VÀ đang ở chế độ Desktop
              ...(open && !isMobile && { display: 'none' }), 
            }}
          >
            <MenuIcon /> 
          </IconButton>
          
          <Typography variant="h6" noWrap component="div">
            Hệ thống Quản lý ADN Nghệ An
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Sidebar component */}
      <Sidebar 
        open={open} 
        handleDrawerClose={handleDrawerClose}
        drawerWidth={drawerWidth} 
        // (*** MỚI ***) Thêm 2 props quan trọng
        variant={isMobile ? 'temporary' : 'permanent'} // Chế độ 'temporary' (overlay) trên mobile
        onClose={handleDrawerToggle} // Hàm để đóng khi bấm ra ngoài (chỉ dùng cho 'temporary')
      />
      
      {/* Box chứa nội dung chính */}
      <Box
        component="main"
        sx={{ 
          flexGrow: 1, 
          // (*** SỬA ***) Giảm padding (p) trên mobile
          p: { xs: 1.5, sm: 3 }, // 1.5 trên mobile (xs), 3 trên desktop (sm)
          marginTop: '64px' 
        }}
      >
        {/* Nội dung trang */}
        {children} 
      </Box>
    </Box>
  );
}

export default Layout;